
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
import { PantryVirtualData, PantryVirtualDataInfo, PantryVirtualLineInfo, REM_VIRTUAL_LIST_PADDING, REM_VIRTUAL_LIST_FOOD_PADDING } from "@/types/pantry";
import PantryVirtualListItem from "./PantryVirtualListItem.vue";
import { convertRemToPx } from "@/utils/common-utils";

export default defineComponent({
  name: "PantryVirtualListLineView",
  components: {
    PantryVirtualListItem
  },
  props: {
    list: {
      type: PantryVirtualLineInfo,
      default: null,
      required: true
    },
    selectMode: {
      type: Boolean,
      default: false,
      required: true
    },
    linePosition: {
      type: Number,
      default: 0,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    NativeClient.sendDebugLog("PantryVirtualListLineView list=" + JSON.stringify(props.list));
    const getList = () => {
      return (props.list != null && props.list.list != null) ? props.list.list : Array<PantryVirtualDataInfo>();
    };
    const styleView = () => {
      const is3rows = (props.list != null) ? props.list.is3rows : false;
      const itemAreaWidth = window.innerWidth - convertRemToPx(REM_VIRTUAL_LIST_PADDING * 2) - convertRemToPx(REM_VIRTUAL_LIST_FOOD_PADDING * 2);
      const itemWidth = itemAreaWidth / 3;
      const margin = is3rows ? convertRemToPx(REM_VIRTUAL_LIST_PADDING) : (window.innerWidth - (itemWidth * 2) - convertRemToPx(REM_VIRTUAL_LIST_FOOD_PADDING)) / 2;
      return { 'margin-left': `${margin}px`, 'margin-right': `${margin}px` };
    };
    const onSelectCheck = (data: PantryVirtualData, checked: boolean) => {
      context.emit("select-check", data, checked);
    };
    return {
      getList,
      styleView,
      onSelectCheck,
    };
  }
});
